import React, { useMemo } from 'react'
import { DataManagementGrid } from '../Common/DataManagementGrid'
import { adminClassColumns } from '../../Data/ClassManagement/ClassListData'
import { getAllData, deleteIdData } from '../../lib/class'
import { useDataManagement } from '../../Hooks/useDataManagement'
import { useLayout } from '../../Hooks/useLayout'
import { useRoleBasedUrl } from '../../Hooks/useRoleBasedUrl'

const AdminClassList = () => {
	const layout = useLayout()
	const role = useRoleBasedUrl()

	const { data: classes, loading, searchQuery, setSearchQuery, handleDelete } = useDataManagement(getAllData, deleteIdData)

	// Sort classes by name
	const sortedClasses = useMemo(() => {
		return [...classes].sort((a, b) => {
			const nameA = a.class_name ? a.class_name : ''
			const nameB = b.class_name ? b.class_name : ''
			return nameA.localeCompare(nameB)
		})
	}, [classes])

	return (
		<DataManagementGrid
			title="Class Management"
			subTitle="Manage all classes in the system"
			breadcrumbTitle="Class Management"
			breadcrumbMainTitle="Class Management"
			columns={adminClassColumns}
			data={sortedClasses}
			loading={loading}
			searchQuery={searchQuery}
			setSearchQuery={setSearchQuery}
			searchPlaceholder="Search classes..."
			createButtonText="Create New Class"
			createButtonLink={`${process.env.PUBLIC_URL}/${role}/class-management/create/${layout}`}
			onDelete={handleDelete}
			searchFields={['class_name', 'grade']}
			noDataMessage="No classes found"
		/>
	)
}

export { AdminClassList }
